import actionTypes from './actions/actionTypes'

const {
  REQUEST_ROOMS,
  SERVER_ERROR_OCURED,
} = actionTypes

const roomReducer = (
  state = {
    isFetchingRooms: false,
    serverError: false,
  },
  action
) => {
  switch (action.type) {
    case REQUEST_ROOMS:
      return Object.assign({}, state, {
        isFetchingRooms: true
      })
    case SERVER_ERROR_OCURED:
      return Object.assign({}, state, {
        serverError: true
      })
    default:
      return state
  }
}

export default roomReducer



// WEBPACK FOOTER //
// src/routes/Room/reducer.js